import ItemView from './portfolio-item'
import { addClass, isMobile, onResize } from '../utilities'

const SLANT = {
    NONE: null,
    LEFT: 'edge--top--reverse',
    RIGHT: 'edge--top'
};

const balanceRow = (row) => {
    const leftColumn = row.querySelector( '.portfolio-item--left' );
    const rightColumn = row.querySelector( '.portfolio-item--right' );
    onResize( (size)=>{
        leftColumn.style.height = 'initial';
        rightColumn.style.height = 'initial';

        if( !isMobile() ){
            if( rightColumn.offsetHeight > leftColumn.offsetHeight ){
                leftColumn.style.height = rightColumn.offsetHeight + 'px';
            }else{
                rightColumn.style.height = leftColumn.offsetHeight + 'px';
            }
        }
    });
};

export default class
{
    constructor(el){
        let prevSlant = SLANT.RIGHT;
        let items = el.querySelectorAll('.portfolio-item');
        let prevItem = new ItemView(items[0]);
        for( var i=1; i<items.length; i++){
            const child = items[i];
            let item = new ItemView( child );

            let slant = SLANT.LEFT;

            if( prevItem ){
                if( prevItem.features.length !== prevItem.contributions.length ){
                    slant = (prevItem.features.length > prevItem.contributions.length ? SLANT.LEFT : SLANT.RIGHT );
                }else{
                    slant = (prevSlant === SLANT.LEFT ? SLANT.RIGHT : SLANT.LEFT);
                }
            }

            addClass( item.el, slant );

            prevSlant = slant;
            prevItem = item;
        }

        const rows = el.querySelectorAll( '.container--split .row' );
        for( var j=0; j<rows.length; j++){
            const row = rows[j];
            balanceRow( row );
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/js/portfolio/portfolio.js
 **/